import pjson from "../../package.json";
const versionRegex = /(?<major>\d+)\.(?<minor>\d+)\.(?<patch>\d+)(-(?<preRelease>[\w.\d]+))?(\+(?<buildMetadata>\w+))?/;
const defaultVersion = pjson.version;
export const parseVersion = (version = defaultVersion) => {
  const result = versionRegex.exec(version);
  if (!result || !result.groups) {
    console.error("Failed to parse version", version);
    return void 0;
  }
  const versionGroups = result.groups;
  return {
    major: versionGroups == null ? void 0 : versionGroups.major,
    minor: versionGroups == null ? void 0 : versionGroups.minor,
    patch: versionGroups == null ? void 0 : versionGroups.patch,
    preRelease: versionGroups == null ? void 0 : versionGroups.preRelease,
    buildMetadata: versionGroups == null ? void 0 : versionGroups.buildMetadata
  };
};
export const getFullVersion = () => defaultVersion;
export const getMajorAndMinorVersion = () => {
  const result = parseVersion();
  if (!result) {
    return getFullVersion();
  }
  const { major, minor } = result;
  return `${major}.${minor}`;
};
export default {
  parseVersion,
  getMajorAndMinorVersion,
  getFullVersion
};
